import { render, staticRenderFns } from "./TotaisStatus.vue?vue&type=template&id=0789a8c6"
import script from "./TotaisStatus.vue?vue&type=script&lang=js"
export * from "./TotaisStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports